/* eslint-disable i18next/no-literal-string */
// Mirrors SBD TradingAccountType and ApplicationType.ToTradingAccountType().
const missingSeparatorIndex = -1;
const accountTypeCodes: Record<string, number> = {
  Individual: 1,
  Joint: 2,
  Company: 3,
  CorporateTrust: 4,
  Trust: 5,
  SMSF: 6,
  IndividualTrusteeSmsf: 6,
  CorporateTrusteeSmsf: 6,
  Minor: 7,
  RegisteredBody: 8,
  Partnership: 9,
  OneOffSale: 10,
  EstateSale: 11
};

export const buildApplicationSubmittedParameters = (
  userCRC: string | undefined,
  accountType: string | undefined,
  existingParameters: Record<string, any> = {},
  cookieString: string = document.cookie
): Record<string, any> => {
  const cookie = cookieString.split(';').find((entry) => entry.trim().split('=')[0] === '__utmzz');
  const rawCookieValue = cookie ? cookie.trim().slice(cookie.trim().indexOf('=') + 1) : '';
  const utmzz: Record<string, string> = {};
  // Split the raw fields before decoding so escaped pipes stay inside their values.
  rawCookieValue.split('|').forEach((item) => {
    const separatorIndex = item.indexOf('=');
    if (separatorIndex === missingSeparatorIndex) return;
    const key = item.slice(0, separatorIndex).trim();
    if (!key) return;
    const rawValue = item.slice(separatorIndex + 1).trim();
    try {
      utmzz[key] = decodeURIComponent(rawValue.replace(/\+/g, ' '));
    } catch {
      utmzz[key] = rawValue;
    }
  });
  const cleanUtmValue = (value?: string) => (value ? value.replace(/^\((.*)\)$/, '$1') : undefined);
  const parameters: Record<string, any> = {
    ...existingParameters,
    CRC: userCRC,
    AccountTypeCode: accountType && Object.prototype.hasOwnProperty.call(accountTypeCodes, accountType) ? accountTypeCodes[accountType] : undefined,
    'UTM Source': cleanUtmValue(utmzz.utmcsr || utmzz.utm_source),
    'UTM Medium': cleanUtmValue(utmzz.utmcmd || utmzz.utm_medium),
    'UTM Campaign': cleanUtmValue(utmzz.utmccn || utmzz.utm_campaign),
    'UTM Content': cleanUtmValue(utmzz.utmcct || utmzz.utm_content),
    'UTM Term': cleanUtmValue(utmzz.utmctr || utmzz.utm_term)
  };
  Object.keys(parameters).forEach((key) => {
    if (parameters[key] === null || parameters[key] === undefined || parameters[key] === '') delete parameters[key];
  });
  return parameters;
};
